const globalConsts = {
  INPUT_FILES_CORPORATE_OWNERSHIP_CSCDOCUMENT: 'cscDocument',

  INPUT_FILES_CORPORATE_DECLARATIONS_COIDOCUMENT: 'coiDocument',
  INPUT_FILES_CORPORATE_DECLARATIONS_MOADOCUMENT: 'moaDocument',
  INPUT_FILES_CORPORATE_DECLARATIONS_COSDOCUMENT: 'cosDocument',
  INPUT_FILES_CORPORATE_DECLARATIONS_CDRDOCUMENT: 'cdrDocument',
  INPUT_FILES_CORPORATE_DECLARATIONS_PPDOCUMENT: 'ppDocument',
  INPUT_FILES_CORPORATE_DECLARATIONS_UBDOCUMENT: 'ubDocument',
  INPUT_FILES_CORPORATE_DECLARATIONS_BRDOCUMENT: 'brDocument',
  INPUT_FILES_CORPORATE_DECLARATIONS_RACDOCUMENT: 'racDocument',
  INPUT_FILES_CORPORATE_DECLARATIONS_SSDOCUMENT: 'ssDocument',

  INPUT_FILES_CORPORATE_BANKDETAILS_ASSIDOCUMENT: 'assiDocument',
  INPUT_FILES_CORPORATE_BANKDETAILS_SSIDOCUMENT: 'ssiDocument',

  INPUT_FILES_CORPORATE_EXPERIENCE_TRADEREXPERIENCEFORMS: 'traderExperienceForms',
  INPUT_FILES_CORPORATE_EXPERIENCE_EVIDENCES: 'evidences',

  INPUT_FILES_DELIVERABLE_COMPANY_FINANCIALS_DOCUMENT: 'companyDocument',

  INPUT_FILES_DELIVERABLE_COMPANY_BANKDETAILS_SSIDOCUMENT: 'ssiDocument',
  INPUT_FILES_DELIVERABLE_COMPANY_BANKDETAILS_ASSIDOCUMENT: 'assiDocument',

  INPUT_FILES_DELIVERABLE_DECLARATIONS_COIDOCUMENT: 'coiDocument',
  INPUT_FILES_DELIVERABLE_DECLARATIONS_MOADOCUMENT: 'moaDocument',
  INPUT_FILES_DELIVERABLE_DECLARATIONS_COSDOCUMENT: 'cosDocument',
  INPUT_FILES_DELIVERABLE_DECLARATIONS_CDRDOCUMENT: 'cdrDocument',
  INPUT_FILES_DELIVERABLE_DECLARATIONS_PPDOCUMENT: 'ppDocument',
  INPUT_FILES_DELIVERABLE_DECLARATIONS_UBDOCUMENT: 'ubDocument',
  INPUT_FILES_DELIVERABLE_DECLARATIONS_BRDOCUMENT: 'brDocument',
  INPUT_FILES_DELIVERABLE_DECLARATIONS_RACDOCUMENT: 'racDocument',
  INPUT_FILES_DELIVERABLE_DECLARATIONS_SSDOCUMENT: 'ssDocument',

  INPUT_FILES_CONTROLLING_PERSONS: 'controllingPersonsForm',

  INPUT_FILES_FORMW9: 'formw9',
  INPUT_FILES_FORMW8BEN: 'formW8BEN',

  INPUT_FILES_INDIVIDUAL_ACC_OPENING_PASSPORT: 'passport',
  INPUT_FILES_INDIVIDUAL_ACC_OPENING_DRIVESLICENSE: 'drivingLicense',
  INPUT_FILES_INDIVIDUAL_ACC_OPENING_NATIONALIDENTITYCARD: 'nationalIdentityCard',
  INPUT_FILES_INDIVIDUAL_ACC_OPENING_UTILITYBILL : 'utilityBill',
}

export default globalConsts
